import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
class BannerPins {
  constructor() {
    let panels = gsap.utils.toArray(".js-banner-layer");

    panels.forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: "top top",
        pin: i === panels.length - 1 ? false : true,
        pinSpacing: false,
      });
    });
  }
}

export default BannerPins;
